module.exports = "/static/assets/1fde35a1b32876ae5c1b0307eb5a7f1a.png";